import React from "react";
import ResponsiveAppBar from "../../componets/Navbar/Navbar";
import "./About-us.css";
import imgs from "../../assets/Images/smartphone-controller-mockup_1310-1072.jpg";
import imagess from "../../assets/Images/smartphone-controller-mockup_1310-1072.jpg";
const About = () => {
  return (
    <div>
      <ResponsiveAppBar />
      <h1 className="qq">Hello world</h1>
    </div>
  );
};

export default About;
